<template>
  <router-view />
</template>
<script>
import { EafTenantApi } from '@wiz-api/eaf-tenant-management'
import { EafProfileApi } from '@wiz-api/account'
import axios from 'axios'
import { forIn, cloneDeep } from 'lodash'

export default {
  name: 'layout-fullscreen',
  data() {
    return {
      eafTenantApi: null,
      eafProfileApi: null,
      layoutLoaded: false,
      token: '',
      tenant: {
        id: '',
        name: '',
      },
    }
  },
  computed: {
    globalConfig() {
      return Wiz.globalSettings.globalConfig
    },
  },
  methods: {
    async getUserDetail() {
      const [err, res] = await this.eafProfileApi.getCurrentUserEafProfile()
      if (!err && res.userInfo) {
        const userInfo = {}
        forIn(res.userInfo, (value, key) => {
          const undderscoreKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
          userInfo[undderscoreKey] = value
        })
        console.log(Wiz, 'wiz---')
        await Wiz.AuthHooks.SetUserInfo({
          access_token: this.token,
          profile: { tenantName: this.tenant.name, tenantid: this.tenant.id, ...userInfo },
        })
      }
    },
  },
  async created() {},
  mounted() {
    // 获取主题配置
    const themeConfig = Wiz.globalSettings.layout.config
    let currentTheme = 'darkBlue'
    if (themeConfig) {
      currentTheme = !_.isNil(themeConfig.defaultTheme) ? themeConfig.defaultTheme : ''
    }
    this.$store.dispatch('System/currentTheme', currentTheme)
    document.getElementsByTagName('body')[0].classList.add(currentTheme)
    if (!window.__POWERED_BY_QIANKUN__) {
      // 非低代码
      return
    }
    const appMainMicroi = document.getElementsByClassName('app-main-microi')
    const microiService = document.getElementById('MicroiService')
    // 添加icon start
    const body = document.getElementsByTagName('body')[0]
    const head = document.getElementsByTagName('head')[0]
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = '/lib/iconfont/iconfont.css'
    head.firstChild.appendChild(link)
    console.log(head, 'head')
    const playerPlugins = ['Player.js', 'PlayerUtils.js', 'qwebchannel.js']
    _.forEach(playerPlugins, (name) => {
      const script = document.createElement('script')
      script.src = `/lib/player/${name}`
      body.firstChild.appendChild(script)
    })
    const videoPlugins = ['h5player.min.js']
    _.forEach(videoPlugins, (name) => {
      const script = document.createElement('script')
      script.src = `/lib/video/HKh5Player/${name}`
      body.firstChild.appendChild(script)
    })
    // konva
    const konvaPlugins = ['konva.min.js']
    _.forEach(konvaPlugins, (name) => {
      const script = document.createElement('script')
      script.src = `/static/konva/${name}`
      body.firstChild.appendChild(script)
    })
    // 高德天气查询接口依赖文件
    if (Wiz.globalSettings.globalConfig.amapSecurityJsCode) {
      wiz._AMapSecurityConfig = {
        securityJsCode: Wiz.globalSettings.globalConfig.amapSecurityJsCode,
      }
      const script = document.createElement('script')
      script.src = '/lib/webapi.amap.js'
      body.firstChild.appendChild(script)
      console.warn(wiz, '_AMapSecurityConfig')
    }
    // 添加icon end
    if (
      this.$route.query.ShowClassicTop === 'false' &&
      this.$route.query.ShowClassicLeft === 'false'
    ) {
      microiService.classList.add('full-screen')
      appMainMicroi[0].classList.add('full-screen')
      return
    }
    microiService.classList.remove('full-screen')
    appMainMicroi[0].classList.remove('full-screen')
  },
  destoryed() {},
}
</script>
